export default __webpack_public_path__ + "static/media/trailer.4906c019.glb";